import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const AccountGate = ({ next, children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="h-40 grid place-items-center eyebrow">Loading…</div>;
  if (user) return children;
  return (
    <div data-testid="account-gate" className="bg-white border border-[#E4E1D9] p-8 sm:p-10">
      <p className="eyebrow">Step 1</p>
      <h3 className="mt-3 font-display text-2xl">Create your private account</h3>
      <p className="mt-3 text-sm text-[#57534E] leading-relaxed">
        We only need your full name, email and (optionally) a contact number. Your account lets you submit your details securely and track progress.
      </p>
      <div className="mt-6 flex flex-wrap gap-3">
        <Link to={`/auth?mode=register&next=${next}`} data-testid="gate-register-btn"
          className="h-12 px-6 inline-flex items-center bg-[#9F7E44] text-white text-sm hover:bg-[#866835] transition-colors">Create account</Link>
        <Link to={`/auth?next=${next}`} data-testid="gate-signin-btn"
          className="h-12 px-6 inline-flex items-center border border-[#121417] text-sm hover:bg-[#121417] hover:text-white transition-colors">I already have one</Link>
      </div>
    </div>
  );
};
